import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
})
export class OrdersComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }
  getModuleGroupAndModuleAccess(moduleName: string, groupName: string) {
    return this.authService.getModuleGroupAndModuleAccess(moduleName, groupName);
}

}
